// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"KEvaluationOverview_infoCard__14GqG"};